// extracted by mini-css-extract-plugin
export default {"tag-container":"F7YF9R"};